import { StepPlaceholder } from '../../../StepPlaceholder/StepPlaceholder';

export const BankDetailsPage = () => {
    return <StepPlaceholder />;
};
